import { ContactInfo, ICommunicationApiCall, IRestApiService } from '../types';

class CommunicationApiCall implements ICommunicationApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  contactStudio(id: string, contactInfo: ContactInfo): Promise<void> {
    return this.restApiService.post('communication/' + id, contactInfo);
  }
}

export default CommunicationApiCall;
